module.exports = __webpack_public_path__ + "static/46-2bb47eac4e86687cae094ac261a116e4.png";